var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        { name: "show", rawName: "v-show", value: _vm.show, expression: "show" }
      ],
      staticClass: "lite_popup lite_options"
    },
    [
      _c("div", { staticClass: "lite_popup_box" }, [
        _c("div", { staticClass: "lite_popup_title" }, [
          _c("span", [_vm._v(_vm._s(_vm.$t("language.common.options")))]),
          _vm._v(" "),
          _c("div", {
            staticClass: "icon white-close dialog-close",
            on: {
              click: function($event) {
                return _vm.close()
              }
            }
          })
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "lite_popup_content" },
          [
            _c(
              "el-tabs",
              {
                model: {
                  value: _vm.activeName,
                  callback: function($$v) {
                    _vm.activeName = $$v
                  },
                  expression: "activeName"
                }
              },
              [
                false
                  ? _c(
                      "el-tab-pane",
                      {
                        attrs: {
                          label: _vm.$t("language.popup.thread"),
                          name: "thread"
                        }
                      },
                      [
                        _c("div", { staticClass: "lite_tab_content" }, [
                          _c(
                            "div",
                            { staticClass: "thread_item" },
                            [
                              _c("span", { staticClass: "thread_item_lable" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("language.popup.listThread")) +
                                    ": " +
                                    _vm._s(_vm.options.listThread)
                                )
                              ]),
                              _vm._v(" "),
                              _c("el-slider", {
                                staticClass: "my-slider",
                                attrs: {
                                  "show-tooltip": false,
                                  step: 1,
                                  min: 1,
                                  max: 5,
                                  "show-stops": ""
                                },
                                model: {
                                  value: _vm.options.listThread,
                                  callback: function($$v) {
                                    _vm.$set(_vm.options, "listThread", $$v)
                                  },
                                  expression: "options.listThread"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "thread_item" },
                            [
                              _c("span", { staticClass: "thread_item_lable" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("language.popup.runThread")) +
                                    ": " +
                                    _vm._s(_vm.options.runThread)
                                )
                              ]),
                              _vm._v(" "),
                              _c("el-slider", {
                                staticClass: "my-slider",
                                attrs: {
                                  "show-tooltip": false,
                                  step: 1,
                                  min: 1,
                                  max: 15,
                                  "show-stops": ""
                                },
                                model: {
                                  value: _vm.options.runThread,
                                  callback: function($$v) {
                                    _vm.$set(_vm.options, "runThread", $$v)
                                  },
                                  expression: "options.runThread"
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.options.type == "sync"
                  ? _c(
                      "el-tab-pane",
                      {
                        attrs: {
                          label: _vm.$t("language.popup.syncModes"),
                          name: "sync"
                        }
                      },
                      [
                        _c("div", { staticClass: "lite_tab_content" }, [
                          _c("div", { staticClass: "same_name_desc" }, [
                            _vm._v(_vm._s(_vm.$t("language.popup.selectSync")))
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "sync_way_box" },
                            [
                              _c("el-switch", {
                                staticClass: "sync_way_switch",
                                attrs: {
                                  "active-color": "#409EFF",
                                  "inactive-color": "#DCDFE6"
                                },
                                model: {
                                  value: _vm.realSync,
                                  callback: function($$v) {
                                    _vm.realSync = $$v
                                  },
                                  expression: "realSync"
                                }
                              }),
                              _vm._v(" "),
                              _vm.options.cron == ""
                                ? _c("span", { staticClass: "sync_way" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("language.cloudSync.normalSync")
                                      )
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.options.cron != ""
                                ? _c("span", { staticClass: "sync_way" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "language.cloudSync.realTimeSync"
                                        )
                                      )
                                    )
                                  ])
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "sync_mode_box" },
                            [
                              _c(
                                "el-radio",
                                {
                                  attrs: { label: "one" },
                                  model: {
                                    value: _vm.options.syncMode,
                                    callback: function($$v) {
                                      _vm.$set(_vm.options, "syncMode", $$v)
                                    },
                                    expression: "options.syncMode"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("language.popup.onewaySync"))
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _c(
                                "el-radio",
                                {
                                  attrs: { label: "two" },
                                  model: {
                                    value: _vm.options.syncMode,
                                    callback: function($$v) {
                                      _vm.$set(_vm.options, "syncMode", $$v)
                                    },
                                    expression: "options.syncMode"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("language.popup.twowaySync"))
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.options.syncMode == "one"
                            ? _c("div", { staticClass: "sync_tips" }, [
                                _c("b", [
                                  _vm._v(
                                    _vm._s(_vm.$t("language.popup.tipsFor")) +
                                      " " +
                                      _vm._s(
                                        _vm.$t("language.popup.simpleSync")
                                      )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("language.popup.simpleSyncTip")
                                    )
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.options.syncMode == "two"
                            ? _c("div", { staticClass: "sync_tips" }, [
                                _c("b", [
                                  _vm._v(
                                    _vm._s(_vm.$t("language.popup.tipsFor")) +
                                      " " +
                                      _vm._s(
                                        _vm.$t("language.popup.twowaySync")
                                      )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("language.popup.twowaySyncTip")
                                    )
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "sync_items" },
                            [
                              _c(
                                "el-checkbox",
                                {
                                  model: {
                                    value: _vm.options.logFile,
                                    callback: function($$v) {
                                      _vm.$set(_vm.options, "logFile", $$v)
                                    },
                                    expression: "options.logFile"
                                  }
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("language.popup.automaRename")
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        effect: "light",
                                        placement: "top"
                                      }
                                    },
                                    [
                                      _c("template", { slot: "content" }, [
                                        _c(
                                          "div",
                                          { staticClass: "options_tips" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "language.popup.optionsPrompt"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass:
                                          "icon-util question-mark question-mark-position"
                                      })
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.options.type == "tran"
                  ? _c(
                      "el-tab-pane",
                      {
                        attrs: {
                          label: _vm.$t("language.cloudTransfer.transfer"),
                          name: "tran"
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "lite_tab_content" },
                          [
                            _c("div", { staticClass: "same_name_desc" }, [
                              _vm._v(
                                _vm._s(_vm.$t("language.popup.chooseAction"))
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-select",
                              {
                                staticClass: "same_name_items",
                                attrs: {
                                  "popper-class": "same_name_item",
                                  size: "small",
                                  placeholder: " "
                                },
                                model: {
                                  value: _vm.options.sameName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.options, "sameName", $$v)
                                  },
                                  expression: "options.sameName"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.$t("language.popup.skipFile"),
                                    value: "skip"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.$t("language.popup.sourceNewer"),
                                    value: "timeNew"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.$t("language.popup.diffSize"),
                                    value: "sizeDiff"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.$t("language.popup.sourceAll"),
                                    value: "timeNew_sizeDiff"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.$t("language.popup.overWrite"),
                                    value: "overwrite"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.$t("language.popup.rename"),
                                    value: "rename"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "tran_option_items" }, [
                              _c(
                                "div",
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      model: {
                                        value: _vm.options.delete,
                                        callback: function($$v) {
                                          _vm.$set(_vm.options, "delete", $$v)
                                        },
                                        expression: "options.delete"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "language.popup.deleteAllSource"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      model: {
                                        value: _vm.options.keepDate,
                                        callback: function($$v) {
                                          _vm.$set(_vm.options, "keepDate", $$v)
                                        },
                                        expression: "options.keepDate"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("language.popup.keepFileDate")
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      model: {
                                        value: _vm.options.logFile,
                                        callback: function($$v) {
                                          _vm.$set(_vm.options, "logFile", $$v)
                                        },
                                        expression: "options.logFile"
                                      }
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "language.popup.automaRename"
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            effect: "light",
                                            placement: "top"
                                          }
                                        },
                                        [
                                          _c("template", { slot: "content" }, [
                                            _c(
                                              "div",
                                              { staticClass: "options_tips" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "language.popup.optionsPrompt"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("div", {
                                            staticClass:
                                              "icon-util question-mark question-mark-position"
                                          })
                                        ],
                                        2
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      model: {
                                        value: _vm.options.inOneFolder,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.options,
                                            "inOneFolder",
                                            $$v
                                          )
                                        },
                                        expression: "options.inOneFolder"
                                      }
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "language.teamTransfer.allTransferred"
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            effect: "light",
                                            placement: "top"
                                          }
                                        },
                                        [
                                          _c("template", { slot: "content" }, [
                                            _c(
                                              "div",
                                              { staticClass: "options_tips" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "language.teamTransfer.optionActivated"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("div", {
                                            staticClass:
                                              "icon-util question-mark question-mark-position"
                                          })
                                        ],
                                        2
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ])
                          ],
                          1
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-tab-pane",
                  {
                    attrs: {
                      label: _vm.$t("language.popup.email"),
                      name: "email"
                    }
                  },
                  [
                    _c("div", { staticClass: "lite_tab_content" }, [
                      _c(
                        "div",
                        { staticClass: "email_desc" },
                        [
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value: _vm.enableEmail,
                                callback: function($$v) {
                                  _vm.enableEmail = $$v
                                },
                                expression: "enableEmail"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("language.popup.sendEmail")))]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "email_box" },
                        [
                          _c("div", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.enableEmail,
                                expression: "!enableEmail"
                              }
                            ],
                            staticClass: "email_mark"
                          }),
                          _vm._v(" "),
                          _c("el-input", {
                            staticClass: "email_input",
                            attrs: { size: "small", placeholder: "Email" },
                            on: { focus: _vm.onEmailFocus },
                            model: {
                              value: _vm.options.email,
                              callback: function($$v) {
                                _vm.$set(_vm.options, "email", $$v)
                              },
                              expression: "options.email"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "email_test",
                              on: {
                                click: function($event) {
                                  return _vm.sendEmail()
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("language.popup.sendMessage"))
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("el-tab-pane", { attrs: { name: "filter" } }, [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("language.popup.filter")))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "lite_vip_icon" })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "lite_tab_content" }, [
                    _c("div", { staticClass: "tag_desc" }, [
                      _vm._v(_vm._s(_vm.$t("language.popup.filterInclude")))
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "tag_box myscroll" },
                      [
                        _vm._l(_vm.options.allowedExtensions, function(tag) {
                          return _c(
                            "el-tag",
                            {
                              key: tag,
                              attrs: {
                                closable: "",
                                "disable-transitions": false,
                                color: "#5562b430",
                                effect: "plain",
                                type: "info"
                              },
                              on: {
                                close: function($event) {
                                  return _vm.handleCloseIncluded(tag)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(tag) +
                                  "\n                            "
                              )
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _vm.inputVisibleIncluded
                          ? _c("el-input", {
                              ref: "saveTagInput",
                              staticClass: "input-new-tag",
                              attrs: { size: "small" },
                              on: { blur: _vm.handleInputConfirmIncluded },
                              nativeOn: {
                                keyup: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.handleInputConfirmIncluded($event)
                                }
                              },
                              model: {
                                value: _vm.inputValueIncluded,
                                callback: function($$v) {
                                  _vm.inputValueIncluded = $$v
                                },
                                expression: "inputValueIncluded"
                              }
                            })
                          : _c(
                              "button",
                              {
                                staticClass: "button-new-tag",
                                attrs: { size: "small" },
                                on: { click: _vm.showInputIncluded }
                              },
                              [
                                _vm._v(
                                  "+ " +
                                    _vm._s(
                                      _vm.$t("language.popup.newFilterTag")
                                    )
                                )
                              ]
                            )
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "tag_desc" }, [
                      _vm._v(_vm._s(_vm.$t("language.popup.filterExclude")))
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "tag_box myscroll" },
                      [
                        _vm._l(_vm.options.excludeNames, function(tag) {
                          return _c(
                            "el-tag",
                            {
                              key: tag,
                              attrs: {
                                closable: "",
                                "disable-transitions": false,
                                color: "#5562b430",
                                effect: "plain",
                                type: "info"
                              },
                              on: {
                                close: function($event) {
                                  return _vm.handleCloseExclude(tag)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(tag) +
                                  "\n                            "
                              )
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _vm.inputVisibleExclude
                          ? _c("el-input", {
                              ref: "saveTagInput",
                              staticClass: "input-new-tag",
                              attrs: { size: "small" },
                              on: { blur: _vm.handleInputConfirmExclude },
                              nativeOn: {
                                keyup: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.handleInputConfirmExclude($event)
                                }
                              },
                              model: {
                                value: _vm.inputValueExclude,
                                callback: function($$v) {
                                  _vm.inputValueExclude = $$v
                                },
                                expression: "inputValueExclude"
                              }
                            })
                          : _c(
                              "button",
                              {
                                staticClass: "button-new-tag",
                                attrs: { size: "small" },
                                on: { click: _vm.showInputExclude }
                              },
                              [
                                _vm._v(
                                  "+ " +
                                    _vm._s(
                                      _vm.$t("language.popup.newFilterTag")
                                    )
                                )
                              ]
                            )
                      ],
                      2
                    )
                  ])
                ])
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "lite_popup_footer" }, [
          _c(
            "button",
            {
              staticClass: "white",
              on: {
                click: function($event) {
                  return _vm.close()
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("language.common.cancel")))]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              on: {
                click: function($event) {
                  return _vm.ok()
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("language.common.save")))]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e72f6452", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e72f6452","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/workspace/lite_options.vue
// module id = null
// module chunks = 